module.exports = __webpack_public_path__ + "static/media/paypal.15685673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/paypal.png
// module id = 647
// module chunks = 0